module.exports = __webpack_public_path__ + "static/desarrollo-software-775d709e20f6185c1d24931aa0684be0.svg";